import { CheckSquare, LayoutGrid, Sparkles, Users, FolderOpen, Plus, CalendarDays } from 'lucide-react';

const tabs = [
  { id: 'cockpit', label: 'Dashboard', icon: LayoutGrid },
  { id: 'tasks', label: 'Tasks', icon: CheckSquare },
  { id: 'schedule', label: 'Schedule', icon: CalendarDays },
  { id: 'habits', label: 'Habits', icon: Sparkles },
  { id: 'oneOnOne', label: '1:1s', icon: Users },
];

export default function MobileNav({ activeTab, setActiveTab, onAdd, showAdd = false }) {
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-[100] bg-white/95 backdrop-blur-xl border-t border-border safe-area-bottom">
      <div className="flex items-center justify-around px-2 py-1">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex flex-col items-center gap-0.5 py-2 px-3 rounded-lg cursor-pointer border-none transition-all ${
              activeTab === tab.id
                ? 'text-accent'
                : 'text-text-tertiary hover:text-text-secondary'
            }`}
          >
            <tab.icon size={20} strokeWidth={activeTab === tab.id ? 2 : 1.5} />
            <span className="text-[10px] font-medium">{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Floating Add Button */}
      {showAdd && onAdd && (
        <button
          onClick={onAdd}
          className="absolute -top-14 right-4 w-12 h-12 rounded-full bg-accent text-white shadow-lg shadow-accent/30 flex items-center justify-center cursor-pointer border-none hover:bg-orange-hover transition-all"
        >
          <Plus size={24} strokeWidth={2.5} />
        </button>
      )}
    </nav>
  );
}
